exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lernsets-reader-cta{background-color:rgba(0,0,0,0);border:2px solid #4298b5;color:#4298b5}.lernsets-reader-cta:hover{color:#4298b5;border-color:rgba(0,0,0,0)}", ""]);
